"use client";

import PropTypes from "prop-types";
import NextImage from "@components/Image/NextImage";
import { useAppContext } from "@components/Provider";
import styles from "./AmazonPreviewLink.module.css";

const AmazonPreviewLink = (props) => {
  const { data } = useAppContext();

  const affiliateCode = data?.SiteSettings?.preview_link_affiliate_code || "";

  const previewLinkInner = (
    <>
      READ PREVIEW
      <NextImage
        ImageUrl={`${process.env.S3_IMAGE_URL}/eye.svg`}
        Title={"Read Preview"}
        Alt_Text={"Read Preview"}
        width={16}
        height={16}
        style={{ verticalAlign: "top", marginLeft: "5px" }}
      />
    </>
  );

  return (
    <div className={["afb__preview-link", styles["afb__preview-link"], props.class || "", props.styledClass || ""].join(" ")}>
      <a
        href={`https://read.amazon.com/kp/card?asin=${props.asin}&tag=${affiliateCode}`}
        target="_blank"
        rel="noopener noreferrer"
        data-vars-book-preview-event-label={props.asin}
      >
        {previewLinkInner}
      </a>
    </div>
  );
};

AmazonPreviewLink.propTypes = {
  asin: PropTypes.string,
};

export default AmazonPreviewLink;
